import { getFacingCount } from '@/lib/utils'
import EmptyShelf from '@components/shelfDetails/EmptyShelf'
import ImageViewShelf from '@components/shelfDetails/ImageViewShelf'
import ProductViewShelf from '@components/shelfDetails/ProductViewShelf'
import SchematicViewShelf from '@components/shelfDetails/SchematicViewShelf'
import ShelfLikeViewShelf from '@components/shelfDetails/ShelfLikeViewShelf'
import { type ViewType } from '@components/shelfDetails/utils'

import type { FacingProducer } from './ShelfDetails'
import type { Shelf } from '@state/shelf/types'

interface ShelfVisualizerProps {
    shelf: Shelf
    type: ViewType
    facingProducer?: FacingProducer
}

function SingleShelfView({ shelf, type, facingProducer }: ShelfVisualizerProps) {
  const shelfId = shelf.id
  const hasFacings = getFacingCount(shelf) > 0

  if (!hasFacings) return <EmptyShelf shelfId={shelfId} />

  switch (type) {
    case 'schematic':
      return <SchematicViewShelf shelfId={shelfId} facingProducer={facingProducer} />
    case 'product':
      return <ShelfLikeViewShelf shelfId={shelfId} facingProducer={facingProducer} />
    case 'productLegacy':
      return <ProductViewShelf shelfId={shelfId} facingProducer={facingProducer} />
    case 'image':
      return <ImageViewShelf />
    default:
      throw new Error(`Unsupported view type: ${type}`)
  }
}

export default SingleShelfView